import { render, staticRenderFns } from "./ScreenTimeManagementModal.vue?vue&type=template&id=98012a88&"
import script from "./ScreenTimeManagementModal.vue?vue&type=script&lang=js&"
export * from "./ScreenTimeManagementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports